import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import ManjuuGamesText from '~/images/ManjuuGamesText.png';

const Index: React.FC<any> = () => {
  return (
    <div className={styles.mj_compInfo_container}>
      <div className={styles.mj_compInfo_content}>
        <div className={styles.mj_compInfo_content_left}>
          <div className={styles.mj_compInfo_content_left_title}>蛮啾网络</div>
          <div className={styles.mj_compInfo_content_left_subTitle}>
            公司介绍
          </div>
          <Image
            src={ManjuuGamesText}
            height={49}
            width={499}
            alt="MANJUU GAMES"></Image>
          <div className={styles.mj_compInfo_trim}></div>
        </div>
        <div className={styles.mj_compInfo_content_middle}></div>
        <div className={styles.mj_compInfo_content_right}>
          <p>
            上海蛮啾网络科技有限公司（Manjuu Co.,
            Ltd.）于2015年01月成立。因为LOGO标志性的形象“啾”和主题色，“蛮啾”也被玩家亲切地称之为“小黄鸡”。
          </p>
          <br />
          <p>
            目前，蛮啾主要作品为二次元战舰策略手游《碧蓝航线》，游戏相关产品已登陆海内外市场并取得优秀的成绩。
          </p>
          <br />
          <p>
            同时，蛮啾一直致力于原创游戏的不断创新，更在原创IP、漫画、动画、周边等更多的领域上不断探索和努力，并有自研产品正在锐意开发中。
          </p>
        </div>
      </div>
    </div>
  );
};

export default Index;
